<template>
<div style="min-height:200px;">
  <el-row type="flex" class="title-bar" :style="'justify-content:' + (operationFlag ? 'flex-end;' : 'space-between;')">
    <w-perf-analysis-time-info v-if="!operationFlag" :ref="timeInfoRef" fixed-time-type="current" :checkDatetime="checkDatetime" @reload="onCurrentDataReLoad"/>
    <div class="vertical-center-box">
      <el-radio-group class="mr-r10" v-model="queryType">
        <el-radio :label="queryTypeData.query" @change="onQueryTypeChange">과점유 SQL</el-radio>
        <el-radio :label="queryTypeData.diskRead" @change="onQueryTypeChange">DISK Read</el-radio>
      </el-radio-group>
      <el-select v-show="queryType !== queryTypeData.query" style="width:255px;" v-model="diskReadQueryId" @change="loadData">
        <el-option v-for="item in diskReadQueryIds" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <w-header-search-button v-show="queryType === queryTypeData.query" @click="onShowSearchToolButtonClick"></w-header-search-button>
    </div>
  </el-row>
  <!-- 과점유 SQL 테이블 -->
  <el-table-wrapper v-show="queryType === queryTypeData.query" v-loading="isLoading.query" ref="table" :data="tableData" :column-default="columnDefault" :columns="columns" :show-custom-header="true" :pagination="true" :show-search-tool="showSearchTool">
    <template slot="sql-slot" slot-scope="scope">
      <i class="far fa-search-plus c-pointer" @click="showSqlDetailPopup(scope.row.SQL_TEXT)" />
    </template>
  </el-table-wrapper>
  <!-- Disk Read -->
  <el-input v-show="queryType !== queryTypeData.query" v-loading="isLoading.diskReead" type="textarea" :autosize="{ minRows: 6 }" readonly v-model="diskReadData"></el-input>
  <!-- SQL 상세 팝업 -->
  <w-sliding-popup ref="slidingPopup" title="상세보기" width="600px" @close="onSqlDetailPopupClose">
    <div slot="content">
      <div class="title-bar title-h4">SQL문</div>
      <el-input type="textarea" :autosize="{ minRows: 6 }" readonly v-model="selectedSqlText"></el-input>
    </div>
  </w-sliding-popup>
</div>
</template>
<script>
import { convertValuByUnit } from '@/utils/number';
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { columnDefault } from '@/constants/table';
import WPerfAnalysisTimeInfo from '@/views/performance/node/analysis/components/PerfAnalysisTimeInfo';
import msgUtil from '@/utils/message';
import databaseTableInfoAPI from '@/api/performance/database/database-table-info';
import AnalysisTableMixin from '@/mixins/performance/analysis-table-ex';

export default {
  name: 'WOligopolyQuery',
  mixins: [AnalysisTableMixin],
  components: { WPerfAnalysisTimeInfo },
  data() {
    return {
      queryType: 'query',
      queryTypeData: {
        query: 'query',
        diskRead: 'diskRead',
      },
      columnDefault,
      diskReadQueryId: 'DBORDISKReadsLogicalMaxSQL',
      diskReadQueryIds: [
        {
          value: 'DBORDISKReadsLogicalMaxSQL',
          label: '논리적 디스크 읽기 Max SQL',
        },
        {
          value: 'DBORDISKReadsLogicalMaxUser',
          label: '논리적 디스크 읽기 Max User',
        },
        {
          value: 'DBORDISKReadsPhysicalMaxSQL',
          label: '물리적 디스크 읽기 Max SQL',
        },
        {
          value: 'DBORDISKReadsPhysicalMaxSQLCurrentSession',
          label: '물리적 디스크 읽기 Max SQL 현재 세션',
        },
        {
          value: 'DBORDISKReadsPhysicalMaxUser',
          label: '물리적 디스크 읽기 Max User',
        },
      ],
      isLoading: {
        query: false,
        diskRead: false,
      },
      tableData: [],
      diskReadData: '',
      selectedSqlText: '',
      columns: [{
        prop: 'USER',
        label: '사용자',
        sortable: true,
        showOverflowTooltip: true,
        width: 80,
        searchable: true,
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'FIRST_LOAD_TIME',
        label: '시작 일시',
        sortable: true,
        showOverflowTooltip: true,
        width: 140,
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'CPU_TIME',
        label: 'CPU사용시간',
        sortable: true,
        showOverflowTooltip: true,
        width: 120,
        formatter: this.convertKValue,
      }, {
        prop: 'ELAPSED_TIME',
        label: 'CPU구동시간',
        sortable: true,
        showOverflowTooltip: true,
        width: 120,
        formatter: this.convertKValue,
      }, {
        prop: 'RUNTIME_MEM',
        label: 'MEM구동시간',
        sortable: true,
        showOverflowTooltip: true,
        width: 120,
        formatter: this.convertKValue,
      }, {
        prop: 'DISK_READS',
        label: 'DISK I/O',
        sortable: true,
        showOverflowTooltip: true,
        width: 90,
        formatter: this.convertKValue,
      }, {
        prop: 'BUFFER_GETS',
        label: 'Buffer gets 수',
        sortable: true,
        showOverflowTooltip: true,
        width: 120,
        formatter: this.convertKValue,
      }, {
        prop: 'SORTS',
        label: '정렬횟수',
        sortable: true,
        showOverflowTooltip: true,
        width: 85,
        formatter: this.convertKValue,
      }, {
        prop: 'EXECUTIONS',
        label: '실행횟수',
        sortable: true,
        showOverflowTooltip: true,
        width: 85,
        formatter: this.convertKValue,
      }, {
        prop: 'LOADS',
        label: '로딩횟수',
        sortable: true,
        showOverflowTooltip: true,
        width: 85,
        formatter: this.convertKValue,
      }, {
        prop: 'PARSING_USER_ID',
        label: '파싱유저 ID',
        sortable: true,
        showOverflowTooltip: true,
        width: 105,
        formatter: this.convertKValue,
      }, {
        prop: 'PARSING_SCHEMA_ID',
        label: '파싱 스키마 ID',
        sortable: true,
        showOverflowTooltip: true,
        width: 120,
        formatter: this.convertKValue,
      }, {
        prop: 'ADDRESS',
        label: '주소',
        sortable: true,
        searchable: true,
        showOverflowTooltip: true,
        formatter: this.getTableValueAfterCheckEmpty,
      }, {
        prop: 'SQL_TEXT',
        scopedSlot: 'sql-slot',
        label: 'SQL문',
        sortable: true,
        showOverflowTooltip: true,
        searchable: true,
        align: 'center',
        width: 70,
        formatter: this.getTableValueAfterCheckEmpty,
      }],
      showSearchTool: false,
      checkDatetime: null,
    };
  },
  methods: {
    /**
     * 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      if (this.queryType === this.queryTypeData.query) {
        this.loadQueryData();
      } else {
        this.loadDiskReadData();
      }
    },
    /**
     * 쿼리 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadQueryData() {
      const objProductId = this.selectedNode.obj.objProductId;
      let queryId;
      if (objProductId && objProductId.substring(0, 1) === '8') {
        queryId = 'DBORSQLAreaSortsVersion8';
      } else {
        queryId = 'DBORSQLAreaSorts';
      }
      const dateParams = this.getDatetimeParams();
      const params = {
        objId: this.selectedNode.obj.objId,
        startDatetime: dateParams.startDatetime,
        endDatetime: dateParams.endDatetime,
        queryId,
        parameterMap: { // TODO: DBMS 3차 고도화 시 쿼리 수정할 예정이었으나 포팅 당시는 진행되지 않음. 추후 진행 시 쿼리 수정 후 TOPN, SORTNAME 지워야함. (V11)
          TOPN: 9999,
          STIME: this.getStringDtatetime(dateParams.startDatetime),
          ETIME: this.getStringDtatetime(dateParams.endDatetime),
          SORTNAME: 'USER',
        },
      };
      this.isLoading.query = true;
      databaseTableInfoAPI.getOligopolyQueryList(params).then((result) => {
        if (result.data.success === true) {
          this.tableData = result.data.data;
        } else {
          this.failToLoadQueryData();
        }
      }).catch(() => {
        this.failToLoadQueryData();
      }).finally(() => {
        this.isLoading.query = false;
      });
    },
    /**
     * 쿼리 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadQueryData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '과점유 SQL', false));
    },
    /**
     * Disk Read 데이터를 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDiskReadData() {
      const params = {
        objId: this.selectedNode.obj.objId,
        queryId: this.diskReadQueryId,
      };
      this.isLoading.diskRead = true;
      databaseTableInfoAPI
        .getDiskReadData(params)
        .then((result) => {
          if (result.data.success === true) {
            this.diskReadData = isEmpty(result.data.data) ? '' : result.data.data[0].RESULT;
          } else {
            this.failToLoadDiskReadData();
          }
        }).catch(() => {
          this.failToLoadDiskReadData();
        }).finally(() => {
          this.isLoading.diskRead = false;
        });
    },
    /**
     * Disk Read 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoadDiskReadData() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, 'Disk Read 정보', false));
    },
    /**
     * 쿼리 타입 변경 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onQueryTypeChange() {
      this.loadData();
    },
    /**
     * [changeDataFlag 검색기능 show]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * SQL문 상세 보기 팝업을 연다.
     * @author {name}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    showSqlDetailPopup(sqlText) {
      this.selectedSqlText = sqlText;
      this.$refs.slidingPopup.open();
      // this.sqlLoadStore(address);
      // this.diskReadStore();
    },
    /**
     * SQL 상세 보기 팝업 close event handler
     * @author Ju
     */
    onSqlDetailPopupClose() {
      this.selectedSqlText = '';
    },
    /**
     * [getStringDtatetime date형식을 string형식으로 파싱]
     * @author {Yang}
     * @return {[type]} [description]
     */
    getStringDtatetime(date) {
      return isNil(date) ? '' : `'${getDateToString(date, 'YYYY-MM-DD/HH:mm')}'`;
    },
    /**
     * [thousandUnitParse 천단위 콤보 구분]
     * @author {Yang}
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertKValue(row, column, value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null, true);
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
  },
};
</script>
<style module>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/database/components/table/OligopolyQuery.vue